import { Injectable } from '@angular/core';
import { GenericHttpService } from '../generic.http.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../../../config';
import { map } from 'rxjs/operators';
import { Param } from '../../../model/common/param';
import { AssetStatusDashboard } from '../../../model/api/common/asset-status-dashboard';
import { LocationStatus } from '../../../model/api/common/location-status';
import { Customer } from '../../../model/api/assets/customer';
import { Product } from '../../../model/api/assets/product';
@Injectable()
export class DashboardHttpService extends GenericHttpService<any, number> {

  status: string[] = ['OUTOFSTOCK', 'INSTOCK', 'LOWSTOCK'];

  productNames: string[] = [
      "Bamboo Watch", 
      "Black Watch", 
      "Blue Band", 
      "Blue T-Shirt", 
      "Bracelet", 
      "Brown Purse", 
      "Chakra Bracelet",
      "Galaxy Earrings",
      "Game Controller",
      "Gaming Set",
      "Gold Phone Case",
      "Green Earbuds",
      "Green T-Shirt",
      "Grey T-Shirt",
      "Headphones",
      "Light Green T-Shirt",
      "Lime Band",
      "Mini Speakers",
      "Painted Phone Case",
      "Pink Band",
      "Pink Purse",
      "Purple Band",
      "Purple Gemstone Necklace",
      "Purple T-Shirt",
      "Shoes",
      "Sneakers",
      "Teal T-Shirt",
      "Yellow Earbuds",
      "Yoga Mat",
      "Yoga Set",
  ];

  
  constructor(public http: HttpClient) {
    super(http, '', 'dashboards');
  }

  public budgetStatus(accMonthId: number): Observable<any[]> {
      return this.http.get(AppConfig.urlPrefix + this.url + '/budgetstatus' + `/${accMonthId}`, { headers: this.headers }).pipe(
      map((data: any[]) => {
          return data;
      }));
  }

  public inventoryStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/inventorystatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
    map((data: any[]) => {
        return data;
    }));
}

public costCenterStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/costcenterstatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}

public assetTypeStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/assetTypeStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}

public typeStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/typeStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}

public divisionStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/divisionStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}

public departmentStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/departmentStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}

public projectStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/projectStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}


public budgetManagerStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/budgetManagerStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}


public subTypeStatus(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/subTypeStatus' + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`, { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}

getTotalAssetsByDepartmentId(id: number, type: number): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + `/department/${id}/${type}`).pipe(
      map((data: any[]) => {
          return data;
      }));
}

public exportTotalAssetsByDepartment(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/department` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}


public exportTotalAssetsByBudgetManager(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/budgetManager` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}

public exportTotalAssetsByDivision(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/division` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}

public exportTotalAssetsByCostCenter(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/costcenter` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}


public exportTotalAssetsByType(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/type` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}

public exportTotalAssetsByAssetType(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/assettype` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}

public exportTotalAssetsByProject(inventoryId: number, departmentId: number, divisionId: number, costCenterId: number, typeId: number, assetTypeId: number, projectId: number) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url +   `/export/project` + `/${inventoryId}` + `/${departmentId}` + `/${divisionId}` + `/${costCenterId}` + `/${typeId}` + `/${assetTypeId}` + `/${projectId}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res));
}



// public exportTotalAssetsByCostCenterId(id: number, type: number) {
//   let searchParams: HttpParams = null;
//   let url = AppConfig.urlPrefix + this.url +   `/export/costCenter/${id}/${type}`;
//   return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
//                   map(res => res));
// }


public export(params: Array<Param>) {
  let searchParams: HttpParams = null;
  let url = AppConfig.urlPrefix + this.url + '/export';

  searchParams = this.getSearchParams(params);
  return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                  map(res => res))
}




public assetStatus(params: Array<Param>): Observable<AssetStatusDashboard> {
  let searchParams: HttpParams = null;
  searchParams = this.getSearchParams(params);

  return this.http.get(AppConfig.urlPrefix + this.url + '/assetStatus', { params: searchParams,  headers: this.headers }).pipe(
  map((data: AssetStatusDashboard) => {
      return data;
  }));
}

public locationStatus(): Observable<LocationStatus[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/locationstatus', { headers: this.headers }).pipe(
  map((data: LocationStatus[]) => {
      return data;
  }));
}

public project(accMonthId: number,projectId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/project' + `/${accMonthId}`+ `/${projectId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public projectGroup(accMonthId: number,projectId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/projectGroup' + `/${accMonthId}`+ `/${projectId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public countryGroup(accMonthId: number, countryId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/countryGroup' + `/${accMonthId}`+ `/${countryId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public admCenterGroup(accMonthId: number, admCenterId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/admCenterGroup' + `/${accMonthId}`+ `/${admCenterId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public regionGroup(accMonthId: number, regionId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/regionGroup' + `/${accMonthId}`+ `/${regionId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public assetTypeGroup(accMonthId: number, assetTypeId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/assetTypeGroup' + `/${accMonthId}`+ `/${assetTypeId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public companyGroup(accMonthId: number, companyId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/companyGroup' + `/${accMonthId}`+ `/${companyId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public companyDynamicGroup(accMonthId: number, companyId: number, countryId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/companyDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` + `/${activityId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public departmentDynamicGroup(accMonthId: number, companyId: number, countryId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/departmentDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` + `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public divisionDynamicGroup(accMonthId: number, companyId: number, countryId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/divisionDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` + `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public admCenterDynamicGroup(accMonthId: number, companyId: number, countryId: number, departmentId: number, divisionId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/admCenterDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${departmentId}` + `/${divisionId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` +
  `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public regionDynamicGroup(accMonthId: number, companyId: number, countryId: number, departmentId: number, divisionId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/regionDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${departmentId}` + `/${divisionId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` + 
  `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public assetTypeDynamicGroup(accMonthId: number, companyId: number, countryId: number, departmentId: number, divisionId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/assetTypeDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${departmentId}` + `/${divisionId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}`
   + `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public projectDynamicGroup(accMonthId: number, companyId: number, countryId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/projectDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` + `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public projectTypeDynamicGroup(accMonthId: number, companyId: number, countryId: number, departmentId: number, divisionId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, parentId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/projectTypeDynamicGroup' + `/${accMonthId}` + `/${companyId}` +
  `/${countryId}` + `/${departmentId}` + `/${divisionId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}`
   + `/${activityId}` + `/${parentId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

public dynamicGroupMonth(accMonthId: number, companyId: number, departmentId: number, divisionId: number, countryId: number, projectId: number, admCenterId: number,
  regionId: number, assetTypeId: number, activityId: number, projectTypeId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/dynamicGroupMonth' + `/${accMonthId}` + `/${companyId}` + `/${departmentId}` + `/${divisionId}` +
  `/${countryId}` + `/${projectId}` + `/${admCenterId}` + `/${regionId}` + `/${assetTypeId}` + `/${activityId}` + `/${projectTypeId}`, { headers: this.headers }).pipe(
  map((data: Response) => {
      return data;
  }));
}

getCustomersMedium() {
  return this.http.get<any>('../../../../assets/customers-medium.json')
      .toPromise()
      .then(res => <Customer[]>res.data)
      .then(data => data);
}

getProductsSmall() {
  return this.http.get<any>('assets/products-small.json')
  .toPromise()
  .then(res => <Product[]>res.data)
  .then(data => { return data; });
}

getProducts() {
  return this.http.get<any>('assets/products.json')
  .toPromise()
  .then(res => <Product[]>res.data)
  .then(data => { return data; });
}

getProductsWithOrdersSmall() {
  return this.http.get<any>('assets/products-orders-small.json')
  .toPromise()
  .then(res => <Product[]>res.data)
  .then(data => { return data; });
}

generatePrduct(): Product {
  const product: Product =  {
      id: this.generateId(),
      name: this.generateName(),
      description: "Product Description",
      price: this.generatePrice(),
      quantity: this.generateQuantity(),
      category: "Product Category",
      inventoryStatus: this.generateStatus(),
      rating: this.generateRating()
  };

  product.image = product.name.toLocaleLowerCase().split(/[ ,]+/).join('-')+".jpg";;
  return product;
}

generateId() {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
  for (var i = 0; i < 5; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  
  return text;
}

generateName() {
  return this.productNames[Math.floor(Math.random() * Math.floor(30))];
}

generatePrice() {
  return Math.floor(Math.random() * Math.floor(299)+1);
}

generateQuantity() {
  return Math.floor(Math.random() * Math.floor(75)+1);
}

generateStatus() {
  return this.status[Math.floor(Math.random() * Math.floor(3))];
}

generateRating() {
  return Math.floor(Math.random() * Math.floor(5)+1);
}

public employeesStatus(): Observable<any[]> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/employeesstatus', { headers: this.headers }).pipe(
  map((data: any[]) => {
      return data;
  }));
}


}
